import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";
import { ApiCallService } from "./api-call.service";
import { RequestCountHttpInterceptorService } from "./request-count-http-interceptor.service";
import { Session } from "./session.service";
import {RoutesEnum} from "../enums/routes.enum";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private notificationsSource = new BehaviorSubject<any[]>([]);
  notifications = this.notificationsSource.asObservable();
  private hasNotificationsSource = new BehaviorSubject<boolean>(false);
  hasNotifications = this.hasNotificationsSource.asObservable();
  private notificationsCountSource = new BehaviorSubject<number>(0);
  notificationsCount = this.notificationsCountSource.asObservable();

  private continuePolling:boolean = true;
  private currentUser;

  constructor(
    private apiCall: ApiCallService,
    private session:Session,
    private requestCountHttpInterceptorService: RequestCountHttpInterceptorService
  ) { }

  updateNotifications(notifications: any[]) {
    this.notificationsSource.next(notifications);
  }
  updateHasNotifications(data: boolean) {
    this.hasNotificationsSource.next(data);
  }
  updateNotificationsCount(data: number) {
    this.notificationsCountSource.next(data);
  }

  getUnreadNotifications(){
    let allNotifications = this.notificationsSource.getValue();
    this.currentUser = this.session.getUser();
    setTimeout(() => {
      //if every ajax call has already finished, then call getUnreadNotifications
      if(this.requestCountHttpInterceptorService.pendingRequestsCount === 0 && this.continuePolling) {
        this.apiCall.getData('/aeAMSgetUnreadNotifications/', {pcRequestKey: this.currentUser.userRequestKey}) //this will also mark them as read
          .subscribe( (response) => {
            if (response.success) {
              let notifications = response.data[0].dataSet;
              notifications = notifications.filter(notification => {
                let canBeAdded = true;
                for(let existingNotification of allNotifications){
                  if(notification.requestKey === existingNotification.requestKey){
                    canBeAdded = false;
                  }
                }
                return canBeAdded;
              })
              notifications.forEach((notification) => {
                notification.unread = true;
                const routeObject =  this.getNotificationRoute(notification.uiRoute);
                notification.routerLink = routeObject ? routeObject.routerLink : null;
                notification.queryParams = routeObject ? routeObject.queryParams : null;
              })
              allNotifications = allNotifications.concat(notifications); //keep existing notifications and add to them!
              this.updateNotifications(allNotifications);
              this.updateNotificationsCount(allNotifications.length);
              this.updateHasNotifications(false); //since marked as read
            }
          });
      }
      else{
        setTimeout( () =>  {
          this.getUnreadNotifications();
        }, 250);
      }
    }, 20);

  }

  getNotificationRoute(uiRoute) {
    if(uiRoute && typeof uiRoute.routeName !== 'undefined'){
     /* if(uiRoute.routeName == 'feedbackWorkspace'){
        return {routerLink: 'master-feedback-workspace.accreditor-feedback-workspace', params: {programRequestKey : uiRoute.routeParams.feedbackGUID, feedbackRequestKey : uiRoute.routeParams.feedbackGUID }};
      }*/
      /*if(uiRoute.routeName == 'responsePage'){
        return {routerLink: ['/accreditation/workspace', RoutesEnum.Institution], params: {schoolResponseRequestKey : uiRoute.routeParams.responseGUID}};
      }
      else if(uiRoute.routeName == 'programResponses'){
        return {name: 'app.school-program', params: {programRequestKey : uiRoute.routeParams.programGUID}};
      }*/
      if(uiRoute.routeName == 'directoryInstitutionEditState'){
        return {routerLink: ['/directory/institutions', uiRoute.routeParams.institutionRequestKey], queryParams: {activeTab: 1}};
      }
      else if(uiRoute.routeName == 'directoryProgramEditState'){
        return {routerLink: ['/directory/program', uiRoute.routeParams.institutionRequestKey, uiRoute.routeParams.programRequestKey], queryParams: {activeTab: 1}};
      }
    }
    return null;
  }

  checkIfRead(){
    let notifications = this.notificationsSource.getValue();
    return notifications.filter(function(n){
      return n.unread;
    }).length !== 0;
  }

  getNotificationsCount() {
    if(!this.currentUser) {
      this.currentUser = this.session.getUser();
    }
    //if every ajax call has already finished, them call getUnreadNotifications
    if(this.requestCountHttpInterceptorService.pendingRequestsCount === 0) {
      this.apiCall.getData( '/aeAMSgetUnreadNotificationCount/', { pcRequestKey: this.currentUser.userData.requestKey } )
        .subscribe( ( response ) => {
          if( response.success ) {
            this.updateHasNotifications(response.data[ 0 ].dataSet > 0);
            this.updateNotificationsCount(response.data[ 0 ].dataSet);
          }
        } );
    } else {
      setTimeout( () =>  {
        this.getNotificationsCount();
      }, 250);
    }
  }

  setAllNotificationsRead(){
    this.apiCall.postData('/aeAMSmarkNotificatiosnRead/', {pcRequestKey: this.currentUser.userRequestKey});
    let notifications = this.notificationsSource.getValue();
    notifications.forEach((n) => {
      n.unread = false;
    });
    this.updateNotifications(notifications);
  };

}
